module.exports = __webpack_public_path__ + "img/face-flushed.7a4d33fb.svg";